import apiMethod from '../../../services/api-service';
import methods from '../../../services/utility';
import { useState, useEffect } from 'react';
import { useNavigate, Link, Navigate } from 'react-router-dom';

import Preloading from '../../../components/basics/Preloading';

// assets
import back from "../../../assets/images/icons/arrow-right2.svg";
import emptyMenu from "../../../assets/images/img/emptyMenu.svg";

const WaiterHome = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [cashDesks, setCashDesks] = useState([]);
    const [waiterBaseInfo, setWaiterBaseInfo] = useState({
        userId: 0,
        profileId: 0,
        firstName: "",
        lastName: "",
        avatar: null,
        employeeId: 0,
        branchTitle: "",
        employeeCode: "",
        employeeType: 0,
        branchId: 0,
        restaurantId: 0
    });
    const [showDesks, setShowDesks] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            await getBaseInfo();
            await getOpenCashDesks();
        }
        fetchData();
    }, []);

    const baseInfoMap = (model) => {
        waiterBaseInfo.userId = model.userId;
        waiterBaseInfo.profileId = model.profileId;
        waiterBaseInfo.firstName = model.firstName;
        waiterBaseInfo.lastName = model.lastName;
        waiterBaseInfo.avatar = model.avatar;
        waiterBaseInfo.employeeId = model.employeeId;
        waiterBaseInfo.branchTitle = model.branchTitle;
        waiterBaseInfo.employeeCode = model.employeeCode;
        waiterBaseInfo.employeeType = model.employeeType;
        waiterBaseInfo.branchId = model.branchId;
        waiterBaseInfo.restaurantId = model.restaurantId;
        setWaiterBaseInfo({ ...waiterBaseInfo });
    }

    const getBaseInfo = async () => {
        const apiRes = await apiMethod.getLoginedWaiterInfo();
        if (!methods.showApiErrors(apiRes))
            return false;
        baseInfoMap(apiRes.data);
    }

    const getOpenCashDesks = async () => {
        const resp = await apiMethod.getAvalibleCashdesks(waiterBaseInfo.branchId);
        if (!methods.showApiErrors(resp))
            return false;

        setCashDesks(resp.data);
    }

    const moduleBinder = () => {
        return (
            <>
                {loading && <Preloading></Preloading>}
                {!showDesks &&
                    <div className='row'>
                        <div className='col-lg-3 col-md-4'>
                            <div className='card mb-4' onClick={() => { setShowDesks(true); }}>
                                <div className='card-body text-center'>
                                    <div>ثبت سفارش</div>
                                    <div>صندوق ها: {cashDesks.length}</div>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-3 col-md-4'>
                            <div className='card mb-4'>
                                <div className='card-body text-center'>
                                    <div>سفارش های من</div>
                                    <div>تعداد: {0}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {showDesks &&
                    <>
                        <div className='mb-4 d-lg-block'>
                            <a onClick={(e) => {
                                e.stopPropagation();
                                e.nativeEvent.stopImmediatePropagation();
                                setShowDesks(false);
                            }} className='text-start mb-3 link back-link'>
                                <span><img src={back} className="" alt="return" /></span>
                                بازگشت
                            </a>
                        </div>
                        <div className='row'>
                            {cashDesks.map((item, index) => (
                                <div key={index} className='col-lg-3 col-md-4'>
                                    <div className='card mb-4' onClick={() => { navigate(`/waiterpanel/ordering/${item.branchId}/${item.id}`) }}>
                                        <div className='card-body text-center'>
                                            <div>{item.title}</div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        {cashDesks.length === 0 && (
                            <div className="text-center">
                                <div>
                                    <img src={emptyMenu} alt='noItem' />
                                </div>
                                <p>صندوق فعالی برای ثبت سفارش موجود نیست، لطفا با مسئول فروش هماهنگی لازم انجام شود.</p>
                            </div>
                        )}
                    </>

                }
            </>
        )
    };

    return (
        <>
            {moduleBinder()}
        </>
    );
}

export default WaiterHome;